import React, { Component, PropTypes } from 'react';
import Fuse from 'fuse.js';
import { List } from '../../components';

class SearchResult extends Component {
  static defaultProps = {
    items: [],
    itemsForSearching: []
  };

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired
      })
    ),
    itemsForSearching: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired
      })
    ),
    search: PropTypes.string.isRequired
  };

  state = {
    searchResources: []
  };

  componentWillReceiveProps({ search }) {
    this.filterResourcesWithSearch(search);
  }

  filterResourcesWithSearch(search) {
    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 1000,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [{ name: 'label', weight: 0.3 }, { name: 'title', weight: 0.7 }]
    };
    const fuse = new Fuse(this.props.itemsForSearching, options);
    if (search.length) {
      const fuseSearch = fuse.search(search);
      this.setState({ searchResources: fuseSearch });
    } else {
      this.setState({ searchResources: this.props.items });
    }
  }

  render() {
    const { items, search } = this.props;
    const { searchResources } = this.state;
    return search.length ? <List items={searchResources} /> : <List items={items} />;
  }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/pages/resources/components/SearchResult/SearchResult.js